import { CurrentUserDto, PublicUserDto } from 'services/User/userService.dto';

export const extractUserName = (user: PublicUserDto | CurrentUserDto) => {
  if (!user) {
    return '';
  }
  return user.lastName ? `${user.firstName} ${user.lastName}` : user.firstName || '';
};
